import { providerActions } from './actions';
import { Provider } from './provider';

export const providerReducer = (state =  new Provider()  , {payload, type} ) => {
  switch (type) {

    case providerActions.FETCH_PROVIDER_FAILED:      
      return state.merge({
        isPending: false,
        error: payload.code
      });
    case providerActions.FETCH_PROVIDER_SUCCESS:
      return state.withMutations(provider => {
        localStorage.setItem('version', payload.version);
        provider.merge({
          version: payload.version,
          sessionId: payload.data.sessionId,
          isPending:false,
          dtCreated: payload.data.dtCreated,
          dtExpiration: payload.data.dtExpiration,
        });
      });
    case providerActions.FETCH_PROVIDER_PENDING:
      return state.set('isPending', true);
    case providerActions.LOAD_PROVIDER:
      return state.merge({
        id: payload.user,
        user:payload.user
      });
    default:
      return state;
  }
}
